module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/license-checked-w-4f4662c8ba4a88ca39626a35b318e022.svg";